import React from "react";
import { SistemaComponenteInterno } from "~/pages/Sistema/componentes";
import { SLTableCell } from "~/pages/Sistema/componentes/SistemaList";
import { ThisTable } from "./styles";

function TableComponent() {
  return (
    <>
      <SistemaComponenteInterno>
        <ThisTable>
          <SLTableCell className="col-w-2" name="id" inputfilter>
            Id
          </SLTableCell>
          <SLTableCell className="col-w-4" name="pesquisa.titulo" inputfilter>
            Pesquisa
          </SLTableCell>
          <SLTableCell name="titulo" inputfilter>
            Titulo
          </SLTableCell>
          <SLTableCell className="col-w-2" name="tipo" inputfilter>
            Tipo
          </SLTableCell>
          <SLTableCell className="col-w-2" name="ordem" inputfilter>
            Ordem
          </SLTableCell>
        </ThisTable>
      </SistemaComponenteInterno>
    </>
  );
}

export default TableComponent;
